<template lang="pug">
.container
  h3 {{$t('Additional info from Chaos')}}
  hr.header
  el-table.selectable(v-if='showErrorMessage===false' :data="tableData" :border="true" size="mini" style="width: 100%" :show-header="false")
    el-table-column(label="Field" prop="field")
    el-table-column(label="Value" prop="value")
  div(v-if="showErrorMessage")
    p(class='danger') No data found in Chaos for this device
</template>
<script>
import Vue from 'vue'
export default {
  props: ['side', 'newEditedDevice'],
  created () {
    this.loadData()
  },
  data () {
    return {
      loading: false,
      data: {},
      showErrorMessage: false
    }
  },
  methods: {
    async loadData () {
      const response = await Vue.axios.post('device/infoFromChaos', { id: this.newEditedDevice.id })
      this.data = response.data
      if (response.data.error) {
        this.showErrorMessage = true // Display the error message
      }
    }
  },
  computed: {
    tableData () {
      const data = this.data
      const tableData = []
      const keysToIgnore = ['components']
      for (const key in data) {
        if (data[key] !== null && data[key] !== '' && !keysToIgnore.includes(key)) {
          tableData.push({
            field: key,
            value: data[key]
          })
        }
      }
      return tableData
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
</style>



// WEBPACK FOOTER //
// src/components/Device/ChaosInfo.vue